module.exports = __webpack_public_path__ + "images/icons_v2/pin-filled-43b05305.svg";